import React from 'react';
import '../App.scss';
import '../Login.scss';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
//import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import { Link, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import axios from 'axios';
import { ReactComponent as Logo } from '../image/logosvg.svg'
import CircularProgress from '@material-ui/core/CircularProgress'
import Header from './Header';
const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  modal: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: '70px',
    width: '300px',
    textAlign: 'center'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  paper: {
      position: 'absolute',
      width: 450,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
  },
  buttonForgot: {
    fontSize: '16px',
    "&:hover, &:focus": {
      cursor: 'pointer'
    }
  },
  closeButton: { cursor:'pointer', float:'right', marginTop: '5px', width: '20px' },
  inputLabel: {
    color: "#00000",
    fontSize: '20px',
    "&.focused": {
      color: "#18EA95",
      //border: "2px solid #18EA95",
      fontSize: "20px"
    },
    '&.MuiInput-underline:after': {
      borderBottomColor: '#18EA95',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: "#18EA95",
      },
      '&:hover fieldset': {
        borderColor: "#18EA95",
      },
      '&.Mui-focused fieldset': {
        borderColor: "#18EA95",
      }
    }
  },
  inputLabelProps: {
    color: '#18EA95',
    fontSize: '20px',
    "&.focused": {
      color: "#18EA95",
      //border: "2px solid #18EA95",
      fontSize: "20px"
    },
  },
  underline: {
    color: "#18EA95" ,
    '&::after': {
      border: '2px solid #18EA95'
    }
  },
  progressAlternate: { 
    color: "#000000"
  }
}));

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();
  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
      outline: "none"
  };
}

function Login(props) {
  //console.log(`APIIII FE:${process.env.PORTAL_API}`)
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = React.useState('')
  const [errorForgotMessage, setErrorForgotMessage] = React.useState('')
  const [infoMessage, setInfoMessage] = React.useState('')
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [inputForgot, setInputForgot] = React.useState({})
  const [input, setInput] = React.useState({})
  const [loading, setLoading] = React.useState(false)

  const handleOpen = () => {
      setErrorMessage('');
      setOpen(true);
  };

  const handleClose = () => {
      setErrorMessage('');
      setInfoMessage('');
      setErrorForgotMessage('');
      setInputForgot({})
      setOpen(false);
  };

  const encryptBase64Password = (s) => {
    var b = new Buffer(s);
    return b.toString('base64');
  }

  const onLogin = () => {
    
    // history.push('/ItemList', { 
    //   items: [],
    //   username: null,
    //   email: 'filipa.b.costa@hmr.co.com',
    //   auxiliarydocuments: [],
    //   emailkam: "",
    //   namekam: "",
    //   country: null,
    //   haia: 'yes',
    // })

    if(!input.username || input.username.trim().length === 0) {
      setErrorMessage('Username is mandatory.')
    } else {
      setLoading(true);
      const e_password = input.hasOwnProperty("password") ? encryptBase64Password(input.password) : "";
      axios.post('/api/items', { username: input.username, password: e_password }).then((result) => {
        setLoading(false);
        if(!result.data.success) {
          setErrorMessage(result.data.error == undefined || result.data.error == null ? 
            'There has been an error on login.' : result.data.error)
        }
        else {
          localStorage.setItem('username', result.data.username)
          localStorage.setItem('email', result.data.email)
          localStorage.setItem('password', e_password)
          history.push('/ItemList', { 
            items: result.data.documents,
            username: result.data.username,
            email: result.data.email,
            auxiliarydocuments: result.data.auxiliarydocuments,
            emailkam: result.data.emailkam,
            namekam: result.data.namekam,
            country: result.data.country,
            haia: result.data.haia,
          })
        }
      })
    }
  }

  const onForgotPassword = () => {
    console.log()
    if(!inputForgot.username || !inputForgot.email || inputForgot.username.trim().length === 0 || inputForgot.email.trim().length === 0) {
      setErrorForgotMessage('Username and email are mandatory.')
    } else {
      axios.post('/api/forgotpassword', { email: inputForgot.email, username: inputForgot.username, host: window.location.hostname }).then((result) => {
        console.log(result.data);
        if(!result.data.success) {
          setErrorForgotMessage('Invalid Credentials.')
          setInfoMessage('')
        }
        if(result.data.success) {
          setInfoMessage('An email with a link to reset your password, was sent to your email box. You can close this popup.')
          setErrorForgotMessage('')
          setInputForgot({})
        }
      })
    }
  }

  const onBackdropClick = () => {
      setErrorMessage('');
      setInfoMessage('');
      setInputForgot({})
  }

  const handleInputChange = (e) => setInput({
    ...input,
    [e.currentTarget.name]: e.currentTarget.value
  })

  const handleInputForgotChange = (e) => setInputForgot({
    ...inputForgot,
    [e.currentTarget.name]: e.currentTarget.value
  })
  return (
    <div className="App">
      <Header showMenu={false}/>
      <div className="flexLoginContainer">
        <div className="column dark">
        </div>
        <div className="column clear">
          <div className="leftColumnContent">
            <p className="text60"><span className="fontGilroyExtraBold">Welcome</span><span className="lightGreen fontArial text60">.</span></p>
            <p className="text22 lineHeight">Thank you for choosing HMR as partner to provide you expertise and knowledge that will support the optimisation of your business.</p>
            <p className="text22">Log in to start exploring our insights</p>
            <form className={classes.form} noValidate>
              <TextField
                InputProps={{
                  classes: {
                    root: classes.inputLabel,
                  }
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabelProps,
                    focused: "focused"
                  }
                }}
                margin="normal"
                fullWidth
                id="username"
                label="User"
                name="username"
                autoComplete="username"
                autoFocus
                //value={username}
                onChange={handleInputChange}
              />
              <TextField
                InputProps={{
                  classes: {
                    root: classes.inputLabel,
                  }
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabelProps,
                    focused: "focused"
                  }
                }}
                margin="normal"
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={handleInputChange}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <div className="bodyButton fullWidth topbottomMargin10" disable={loading} onClick={() => onLogin()}>{ loading ? <CircularProgress className={classes.progressAlternate}/> : <div className="hAlign">Login</div> }</div>
              <div className="error">{errorMessage}</div>
              <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  open={open}
                  onBackdropClick={onBackdropClick}
                  onClose={handleClose}
                  disableAutoFocus={true}
                  style={{ outline: "none"}}
                >
                  <div style={modalStyle} className={classes.paper}>
                  <div><span className="text30 colorBlack">Forgot your password?</span><img onClick={() => handleClose()} src={process.env.PUBLIC_URL + '/image/times.png'} className={classes.closeButton}></img></div>
                  <form className={classes.modal} noValidate>
                    <TextField
                      InputProps={{
                        classes: {
                          root: classes.inputLabel,
                        }
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.inputLabelProps,
                          focused: "focused"
                        }
                      }}
                      margin="normal"
                      required
                      fullWidth
                      name="username"
                      label="Username"
                      id="username"
                      onChange={handleInputForgotChange}
                    />
                    <TextField
                      InputProps={{
                        classes: {
                          root: classes.inputLabel,
                        }
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.inputLabelProps,
                          focused: "focused"
                        }
                      }}
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      onChange={handleInputForgotChange}
                    />
                    <div className="paddingTop"><div onClick={() => onForgotPassword()} className="bodyButton"><div className="hAlign"><span>Email Link</span></div></div></div>
                  </form>
                    { errorForgotMessage !== '' && <div className="error">{errorForgotMessage}</div> }
                    { infoMessage !== '' && <div className="info">{infoMessage}</div> }
                  </div>
              </Modal>
              <Grid container>
                <Grid item xs>
                  <Link onClick={handleOpen} className={classes.buttonForgot} variant="body2">
                    Forgot your password?
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
